
































































import PromocodeCampaign from '@/datatypes/promocode-campaign';
import PromocodeCampaignService from '@/services/promocode-campaign/PromocodeCampaignService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';

export default Vue.extend({
  data: () => ({
    promocodeCampaigns: new Array<PromocodeCampaign>(),
    hasNext: true,
    errorMessage: '',
    promocodeCampaignSearch: { term: '' as string | (string | null)[] },
    nextPointer: undefined as string | undefined,
    promocodeCampaignService: new PromocodeCampaignService(),
  }),

  components: {
    SnackbarMessageHandler,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  methods: {
    routeChanged() {
      if (this.$route.query.term) {
        this.promocodeCampaignSearch.term = this.$route.query.term;
      }

      this.getPromocodeCampaigns();
    },

    getListOptions() {
      return {
        term: this.promocodeCampaignSearch.term,
        next: this.$route.query.next,
      };
    },

    concatResponse(data: PromocodeCampaign[]) {
      this.promocodeCampaigns = this.promocodeCampaigns.concat(data);
    },

    getPromocodeCampaigns() {
      const nextPage = this.$route.query.next;

      this.promocodeCampaignService.list(this.getListOptions()).then((response) => {
        this.concatResponse(response.data.map((data) => new PromocodeCampaign(data)));
        if (!nextPage && this.promocodeCampaigns.length === 0) {
          this.errorMessage = 'No campaigns found.';
        }
        if (response.headers.next) {
          this.nextPointer = response.headers.next;
        } else {
          this.nextPointer = undefined;
          this.hasNext = false;
        }
        if (response.data.length === 0) {
          this.hasNext = false;
        }
      });
    },

    requestNextPage() {
      this.navigateUrl(this.nextPointer);
    },

    navigateUrl(next) {
      const query = this.getListOptions();
      query.next = next;

      this.$router.push({ query }).catch((err) => {
        if (err.name === 'NavigationDuplicated') {
          this.getPromocodeCampaigns();
        } else {
          throw err;
        }
      });
    },

    searchPromocodeCampaign() {
      this.promocodeCampaigns = [];
      this.nextPointer = undefined;

      this.navigateUrl(undefined);
    },
  },
});
